module.exports = __webpack_public_path__ + "static/media/CertificateDesign3.8416f7c2.png";